function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import { space, fontSize, themeGet } from 'styled-system';
import PropTypes from 'prop-types';
import { Text } from '../Text';
import { applyVariations, getPaletteColor, borders, deprecatedColorValue } from '../utils';
var StyledInput = styled.input.withConfig({
  displayName: "Input__StyledInput",
  componentId: "sc-11vydc7-0"
})(["appearance:none;display:block;width:100%;font-family:inherit;color:inherit;background-color:transparent;border-radius:", ";border-width:1px;border-style:solid;padding-top:14px;padding-bottom:14px;padding-left:12px;padding-right:12px;margin:0;::placeholder{color:", ";}::-ms-clear{display:none;}", " ", " ", " ", ";"], themeGet('radius'), getPaletteColor('text.light'), applyVariations('Input'), borders, space, fontSize);
var INPUT_ERROR_TEXT = 'InputHelperText';
export var Input = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _helperText$props;

  var helperText = props.helperText,
      color = props.color,
      restProps = _objectWithoutProperties(props, ["helperText", "color"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledInput, _extends({}, restProps, {
    color: color,
    ref: ref
  })), helperText && /*#__PURE__*/React.cloneElement(helperText, {
    color: (helperText === null || helperText === void 0 ? void 0 : (_helperText$props = helperText.props) === null || _helperText$props === void 0 ? void 0 : _helperText$props.color) || color
  }));
});
var HelperText = styled(Text).attrs(function () {
  return {
    mt: 2,
    fontSize: 1
  };
}).withConfig({
  displayName: "Input__HelperText",
  componentId: "sc-11vydc7-1"
})([""]);

Input.HelperText = function (props) {
  return /*#__PURE__*/React.createElement(HelperText, props, props.children);
};

Input.HelperText.displayName = INPUT_ERROR_TEXT;
Input.displayName = 'Input';
Input.isField = true;
Input.defaultProps = {
  fontSize: [2, null, 1]
};
Input.propTypes = _objectSpread(_objectSpread(_objectSpread({
  id: PropTypes.string.isRequired,
  color: deprecatedColorValue(),

  /**
   * Display text below the input and set error color on input
   */
  helperText: PropTypes.node
}, borders.propTypes), space.propTypes), fontSize.propTypes);
export default Input;